import { render, staticRenderFns } from "./Rate.vue?vue&type=template&id=2fef2536&"
import script from "./Rate.vue?vue&type=script&lang=js&"
export * from "./Rate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/pc/Documents/Programs/Vue/top-ten-naija/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRating } from 'vuetify/lib'
installComponents(component, {VRating})
